import React, { PropsWithChildren, Suspense, useEffect } from 'react';
import { withAuth } from '../../HOC';
import { MainLoader } from '../Common';

function ClientViewLayout({ children }: PropsWithChildren) {
  useEffect(() => {
    // Find and disable the main CSS file
    const mainStylesheet = Array.from(
      document.querySelectorAll('link[rel=stylesheet]')
    )
      .filter(
        (sheet): sheet is HTMLLinkElement => sheet instanceof HTMLLinkElement
      ) // Narrow down to HTMLLinkElement
      .find((sheet) => sheet.href.includes('main'));

    if (mainStylesheet) {
      mainStylesheet.disabled = true;
    }

    // Re-enable the main CSS when the component unmounts
    return () => {
      if (mainStylesheet) {
        mainStylesheet.disabled = false;
      }
    };
  }, []);

  return <Suspense fallback={<MainLoader />}>{children}</Suspense>;
}

export default withAuth(ClientViewLayout);
